var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"label":_vm.i18n(_vm.label),"dense":_vm.outlined,"outlined":_vm.outlined,"readonly":_vm.readonly,"autofocus":_vm.autofocus,"hide-details":_vm.hideDetails,"rows":_vm.rows,"auto-grow":""},model:{value:(_vm.str),callback:function ($$v) {_vm.str=$$v},expression:"str"}})
}
var staticRenderFns = []

export { render, staticRenderFns }